// recon-receivables-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcr.flag.old': 'Old item over 90 days',
  'rcr.flag.overdue30': 'Overdue by more than 30 days',
  'rcr.flag.negative': 'Negative customer balance',
  'rcr.flag.duplicate': 'Possible duplicate',
  'rcr.flag.partlyPaid': 'Partly paid, still open',
  'rcr.flag.creditNoteOpen': 'Credit note not offset',
  'rcr.flag.collection': 'Collection notice sent',
  'rcr.flag.lossRisk': 'Risk of loss',
  'rcr.flag.missingDoc': 'Missing invoice document',
  'rcr.flag.paidAfter': 'Paid after the period date',
  'rcr.flag.creditNoteAfter': 'Credit note after the period date',
  'rcr.flag.disputed': 'Disputed invoice',
  'rcr.age.noDueDate': 'No due date',
  'rcr.age.notDue': 'Not yet due',
  'rcr.age.d1_30': '1–30 days overdue',
  'rcr.age.d31_60': '31–60 days overdue',
  'rcr.age.d61_90': '61–90 days overdue',
  'rcr.age.over90': 'Over 90 days overdue',
  'rcr.collection.noticeOne': 'Collection notice sent',
  'rcr.collection.noticeMany': '{count} collection notices sent',
  'rcr.collection.reminderOne': 'One reminder sent',
  'rcr.collection.reminderMany': '{count} reminders sent',
  'rcr.collection.invoiceSent': 'Invoice sent',
  'rcr.collection.notSent': 'Not sent',
  'rcr.collection.imported': 'Imported open item',
  'rcr.type.creditNote': 'Credit note',
  'rcr.type.invoice': 'Invoice',
  'rcr.type.importedCredit': 'Imported customer credit',
  'rcr.type.importedInvoice': 'Imported invoice',
  'rcr.fallback.importedItem': 'Imported item',
  'rcr.check.ledgerVsSubledger': 'General ledger vs subledger',
  'rcr.check.old': 'Old items over 90 days',
  'rcr.check.overdue30': 'Items overdue by more than 30 days',
  'rcr.check.negative': 'Negative customer balances',
  'rcr.check.partlyPaid': 'Partly paid but still open',
  'rcr.check.creditNoteOpen': 'Credit notes not offset',
  'rcr.check.duplicates': 'Possible duplicates',
  'rcr.check.collection': 'Collection notices sent',
  'rcr.check.lossRisk': 'Items at risk of loss',
  'rcr.check.paidAfter': 'Subsequent payment',
  'rcr.check.creditNoteAfter': 'Credit note after the period date',
  'rcr.check.direct': 'Direct postings on control account',
  'rcr.check.missingDoc': 'Missing invoice document',
  'rcr.check.noSubledgerNote': 'No control account with a subledger in the area',
});
